'use strict';

module.exports = {
    PORTAL_MEMBER: 'portal_member',
    PORTAL_OPS_ADMIN: 'portal_ops_admin',
    CLOUD_IT_ADMIN: 'cloud_it_admin'
};